export const PAYMENT_OPTION = {
    CASH_ON_DELIVERY: "CASH_ON_DELIVERY",
    VISA_CARD: "VISA_CARD",
    BCEL_ONE: "BCEL_ONE",
}